import React, { useEffect, useRef, useState, useCallback } from 'react';
import classNames                                          from 'classnames';
import { useTranslation }                                  from 'react-i18next';

import './style.scss';

import CloseIcon                 from '../icons/CloseIcon';
import { useCompareModal }       from '../../providers/compareModal';
import { useDeleteCompareModal } from '../../providers/deleteCompareModal';

const DeleteCompareModal = function(props) {
  const {
          clearOffers,
          currentOfferLabel,
        } = props;

  const {
          hideModal,
          isSingleDoor,
          open,
        }                    = useDeleteCompareModal();
  const { showCompareModal } = useCompareModal();
  const { t }                = useTranslation();

  const [show, setShow] = useState(false);
  const modalRef        = useRef(null);

  const closeModal = useCallback(() => {
    if (show) {
      setShow(false);
    }
    hideModal();
  }, [show, hideModal]);

  const keyDown = useCallback(
    ({ keyCode }) => {
      if ((open && show && keyCode) === 27) {
        closeModal();
      }
    },
    [open, show, closeModal],
  );

  const handleClickOutside = useCallback(
    (event) => {
      if (
        open &&
        modalRef.current &&
        !modalRef.current.contains(event.target)
      ) {
        closeModal();
      }
    },
    [open, closeModal],
  );

  const removeFromCompare = useCallback(() => {
    if (isSingleDoor) {
      showCompareModal(currentOfferLabel, t('client_compare.delete'));
    }
    clearOffers(isSingleDoor);
    closeModal();
  }, [closeModal, isSingleDoor]);

  useEffect(() => {
    if (show) {
      document.addEventListener('mousedown', handleClickOutside);
      document.addEventListener('touchstart', handleClickOutside);
      document.addEventListener('keydown', keyDown);
    } else {
      document.removeEventListener('mousedown', handleClickOutside);
      document.removeEventListener('touchstart', handleClickOutside);
      document.removeEventListener('keydown', keyDown);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      document.removeEventListener('touchstart', handleClickOutside);
      document.removeEventListener('keydown', keyDown);
    };
  }, [show, handleClickOutside, keyDown]);

  useEffect(() => {
    if (open) {
      if (!show) {
        setTimeout(() => {
          setShow(true);
        }, 100);
      }
    }
  }, [open]);

  useEffect(() => {
    document.body.classList.toggle('fixed', open && show);
  }, [open, show]);

  return (
    <div
      className={classNames('modal-overlay', 'delete_compare_modal_overlay', {
        show,
      })}
    >
      <div className={classNames('modal', 'delete_compare_modal')} ref={modalRef}>
        <span className={'close'} onClick={closeModal}>
          <CloseIcon />
        </span>
        <p className={'modal_title'}>{isSingleDoor
          ? t('client_delete_single_compare_door_title')
          : t('client_delete_all_compare_doors_title')}</p>
        <p className={'modal_description'}>{isSingleDoor
          ? (
            <>
              {t('client_delete_single_compare_door_description.door')}{' '}
              <span>{currentOfferLabel}</span>{' '}
              {t('client_delete_single_compare_door_description.will_be_deleted')}
            </>)
          : t('client_delete_all_compare_doors_description')}</p>
        <div className={'modal_btns_container'}>
          <button className={classNames('btn', 'primary')} onClick={removeFromCompare}>{isSingleDoor
            ? t('btn_delete')
            : t('btn_clear')}</button>
          <button className={classNames('btn', 'fill')} onClick={closeModal}>{t('btn_cancel')}</button>
        </div>
      </div>
    </div>
  );
};

export default DeleteCompareModal;
